/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cart_LoadingInputs */

const en_cart_loading = /** @type {(inputs: Cart_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading your cart…`)
};

const th_cart_loading = /** @type {(inputs: Cart_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลดตะกร้าของคุณ…`)
};

const ja_cart_loading = /** @type {(inputs: Cart_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カートを読み込み中…`)
};

const fr_cart_loading = /** @type {(inputs: Cart_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de votre panier…`)
};

const es_cart_loading = /** @type {(inputs: Cart_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando tu carrito…`)
};

const ru_cart_loading = /** @type {(inputs: Cart_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загружаем корзину…`)
};

const zh_cart_loading = /** @type {(inputs: Cart_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在载入购物车…`)
};

const vi_cart_loading = /** @type {(inputs: Cart_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải giỏ hàng của bạn…`)
};

/**
* | output |
* | --- |
* | "Loading your cart…" |
*
* @param {Cart_LoadingInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const cart_loading = /** @type {((inputs?: Cart_LoadingInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cart_LoadingInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_cart_loading(inputs)
	if (locale === "ja") return ja_cart_loading(inputs)
	if (locale === "fr") return fr_cart_loading(inputs)
	if (locale === "es") return es_cart_loading(inputs)
	if (locale === "ru") return ru_cart_loading(inputs)
	if (locale === "zh") return zh_cart_loading(inputs)
	if (locale === "vi") return vi_cart_loading(inputs)
	return en_cart_loading(inputs)
});